import * as React from "react";
import { Button, Box, Typography, Paper } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { CredentialResponse, CodeResponse} from '@react-oauth/google';
import {
  GoogleOAuthProvider,
  useGoogleLogin,
  useGoogleOneTapLogin,
} from "@react-oauth/google";
import UserService from "../../common/services/user.service";
import styles from "./Login.styles";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import { receiveLoginRequest } from "./actions";
import { selectUser } from "./selectors";

type GoogleAuthResponse = CredentialResponse | CodeResponse;
type GoogleLoginButtonProps = {
  isAuthed: boolean;
  checked: boolean;
};

const GoogleLoginButton = (
  {
    isAuthed,
    checked,
  }: GoogleLoginButtonProps
): React.ReactElement => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const enableOneTap: boolean = pathname === "/login" && checked && !isAuthed;
  const useFedCM = process.env.NODE_ENV === "production" && window.isSecureContext;

  const responseGoogle = (response: GoogleAuthResponse) => {
    if ("code" in response) {
      dispatch(receiveLoginRequest(response.code, "", navigate));
      return;
    }
    if ("credential" in response && response.credential) {
      dispatch(receiveLoginRequest("", response.credential, navigate));
      return;
    }
    console.warn("Something went wrong")
  };

  const handleGoogleAuth = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async (codeResponse) => {
      responseGoogle(codeResponse);
    },
    onError: () => console.error("Login Failed"),
  });

  useGoogleOneTapLogin({
    onSuccess: (credentialResponse) => {
      if (isAuthed) return;
      responseGoogle(credentialResponse);
    },
    onError: () => {
      console.error("One Tap login failed");
    },
    disabled: !enableOneTap,
    auto_select: false,
    use_fedcm_for_prompt: useFedCM,
  });

  return (
    <Button
      variant="contained"
      sx={styles.loginButton}
      onClick={() => {
        (window as any).google?.accounts?.id?.cancel()
        handleGoogleAuth();
      }}
    >
      SIGN IN WITH GOOGLE
    </Button>
  );
};

function Login() {
  const { isAuthed, checked } = useSelector(selectUser);
  return (
    <>
      <Grid
        container
        spacing={0}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={styles.root}
      >
        <Paper sx={styles.loginContainer} elevation={3}>
          <Box sx={styles.imageBox}>
            <img src="/images/logo.jpg" alt="Randvast logo" />
          </Box>
          <Box sx={styles.contentBox}>
            <Box sx={styles.textHolder}>
              <Typography component="div" variant="h1" sx={styles.welcomeTitle}>
                Welcome to RANDVAST workspace!
              </Typography>
              <Typography
                component="div"
                variant="h2"
                sx={styles.welcomeSubTitle}
              >
                Please log in to continue
              </Typography>
            </Box>
            <Box sx={styles.buttonHolder}>
              <GoogleOAuthProvider
                // @ts-ignore
                clientId={UserService.googleClient.id}
              >

                <GoogleLoginButton
                  isAuthed={isAuthed}
                  checked={checked}
                />
              </GoogleOAuthProvider>
            </Box>
          </Box>
        </Paper>
      </Grid>
    </>
  );
}

export default Login;
